import type { AxiosError } from 'axios';
import axios from 'axios';
import useEventsBus from '../composables/useEventsBus';
import type { APIResp } from '../types/APIService';
import { getAPIUrl } from '../utils/getApiUrl';

const axiosConfig = {
  withCredentials: true,
  baseURL: getAPIUrl() ?? 'https://10.90.90.3:8889/api/v1/',
};

export const axiosBasicInstance = axios.create(axiosConfig);

const axiosInstance = axios.create(axiosConfig);

axiosInstance.interceptors.response.use(
  response => response,
  (error) => {
    const err = error as AxiosError<APIResp<any>>;
    // Cancelled via AbortController
    if (err.message === 'canceled' || err.code === 'ERR_CANCELED')
      return;

    // console.error('Unexpected error:', err.response?.data.message ?? 'Validation issue', ' CODE ', err.code, ' MSG ', err.message);
    // Check if the error status is 401
    if (err.response && err.response.status === 401) {
      console.log('redirect to /login');
      window.location.href = `${window.location.origin}/login`;
    }
    else {
      const { emit } = useEventsBus();
      emit('error', err.response?.data ?? { message: 'Validation issue' });
    }

    // Pass the error to the next catch block
    return Promise.reject(error);
  },
);

export default axiosInstance;
